/* unplugin-vue-components disabled */import { render } from "./img-con.vue?vue&type=template&id=5fa3adaa&scoped=true"
import script from "./img-con.vue?vue&type=script&lang=js"
export * from "./img-con.vue?vue&type=script&lang=js"

import "./img-con.vue?vue&type=style&index=0&id=5fa3adaa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa3adaa"]])

export default __exports__